import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageKeysAsSubject: Map<string, BehaviorSubject<string | null>> =
    new Map();

  getValue(key: string): string | null {
    return localStorage.getItem(key);
  }

  setValue(key: string, value: string): void {
    localStorage.setItem(key, value);
    if (!this.storageKeysAsSubject.has(key)) {
      this.storageKeysAsSubject.set(
        key,
        new BehaviorSubject<string | null>(value)
      );
    } else {
      this.storageKeysAsSubject.get(key)!.next(value);
    }
  }

  watchKey(key: string): Observable<string | null> {
    let subject = this.storageKeysAsSubject.get(key);
    if (!subject) {
      const initialValue = localStorage.getItem(key);
      subject = new BehaviorSubject<string | null>(initialValue);
      this.storageKeysAsSubject.set(key, subject);
      // Double-check in case another call set it in the meantime
      subject = this.storageKeysAsSubject.get(key)!;
    }
    return subject.asObservable();
  }

  removeKey(key: string): void {
    localStorage.removeItem(key);
    const subject = this.storageKeysAsSubject.get(key);
    if (subject) {
      subject.next(null);
      subject.complete();
      this.storageKeysAsSubject.delete(key);
    }
  }
}
